import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=8ae9e6e4&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=8ae9e6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae9e6e4",
  null
  
)

export default component.exports